import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo } from 'react';

import { useAnjouan } from './use-anjouan';

function AnjouanUI({ className }) {
  const { id, imageSize } = useAnjouan();

  if (!id) return null;

  return (
    <div
      className={clsx(className, 'sb-Anjouan')}
      data-anj-image-size={imageSize || 60}
      data-anj-image-type="basic-small"
      data-anj-seal-id={id}
      id={`anj-${id}`}
    />
  );
}

AnjouanUI.propTypes = {
  className: PropTypes.string,
};

AnjouanUI.defaultProps = {
  className: undefined,
};

export const Anjouan = memo(AnjouanUI);
